import { mimeTypes } from '../constants/mimeTypes';

const prettyList = new Intl.ListFormat('en', { type: 'unit' });

export const getHumanReadableMimeType = (mimeType: string): Array<string> | undefined => {
  return prettyList
    .formatToParts(mimeTypes[mimeType])
    .filter(elem => elem.value !== ', ')
    .map(elem => elem.value.toUpperCase())
    .slice(0, 2);
};

const prettyListOr = new Intl.ListFormat('en', { type: 'disjunction' });

const getMimeTypeDescription = (accept: string | undefined): string | null => {
  if (!accept) return null;

  const description = accept.split(',').map(getHumanReadableMimeType).flat().filter(Boolean);

  const filteredDescription = description.filter((a, b) => description.indexOf(a) === b);

  return prettyListOr.format(filteredDescription);
};

export default getMimeTypeDescription;
